export const subComponents = (translations) => [
{ name: translations["unpaired_product"] || "Unpaired product", path: '/unpairedProducts', permissions: ['product'] },
{ name: translations["unpaired_palettes"] || "Unpaired palettes", path: '/unpairedPalette', permissions: ['unpaired_palette'] }
]